/**
 * Ceci est un component d'input simple de label = input de forme standard
 * classLabel et classInput sont en props pour pouvoir configurer selon les themes, exemple: classInput="focus:arh-border-green-arh"
 *
 * Si invalid :
 * --> label : condition avec arh-text-black : remplacer par invalid:arh-text-invalidColorTextLabel
 * --> input : arh-text-black : remplacer par invalid:arh-text-invalidColorTextInput + arh-bg-invalidBackgroundInput + remplacer arh-border-greyBorderInput par arh-border-invalidBorderInput
 *
 * Si on veut griser l'input ajouter dans le props classInput : arh-bg-greyInput + mettre un readonly et enlever le focus:arh-...
 */
import React from "react";
import { Input } from "@components/tailwindComponents";

function FormSimple(props) {
  const {
    invalid,
    readOnly,
    onBlur,
    type = "text",
    onClick,
    value = "",
    name = "",
    label = "",
    ParentForm = "",
    placeholder = "",
    classLabel = "",
    classInput = "",
    onChange= "",
    edit = false,
    editIconContainerClass=""
  } = props;

  return (
    <div className={"arh-w-full " + ParentForm}>
      {label && (
        <label
          className={`arh-flex arh-w-full arh-font-poppins arh-font-medium arh-text-xs arh-mb-1 ${
            invalid ? "arh-text-invalidColorTextInput " : readOnly ? "arh-text-greyDisabledText " : "arh-text-darkColor "} ${classLabel}`}
        >
          {label}
        </label>
      )}
      <Input
        onBlur={onBlur}
        onChange={onChange}
        type={type}
        additionnalClas={classInput}
        disabled={readOnly}
        placeholder={placeholder}
        value={value}
        name={name}
        onClick={onClick}
        invalid={invalid}
        edit={edit}
        editIconContainerClass={editIconContainerClass}
      />
    </div>
  );
}

export default FormSimple;
